import React, { useEffect } from "react";
import LOGO from "../../assets/images/logos/logo.png";
import { getSumAssured } from "../../utils/helpers/functions";
import moment from "moment";
import { useReactToPrint } from "react-to-print";

const PolicySavingsScheduleDoc = ({ data, life_cover }) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      // behavior: "smooth",
    });
  }, []);

  return (
    <div>
      <div className='d-flex flex-column justify-content-center align-items-center'>
        <img src={LOGO} alt='logo' width={100} />
        <h4
          className='text-uppercase text-primary fw-bold'
          style={{ fontSize: "30px", color: "#2e3192" }}
        >
          PRUDENT CHOICE MICROINSURANCE
        </h4>
      </div>
      <div
        className='row'
        style={{ marginInlineStart: "0px", marginInlineEnd: "0px" }}
      >
        <div
          className='d-flex justify-content-center align-items-center h-50'
          style={{ backgroundColor: "#727CF5" }}
        >
          <h5
            className='text-uppercase text-white fw-bold font-22'
            style={{ fontSize: "35px" }}
          >
            POLICY SCHEDULE
          </h5>
        </div>
      </div>
      <table class='table table-bordered'>
        <thead></thead>
        <tbody>
          <tr>
            <td>POLICY NO</td>
            <td>{data?.policyAppNumber}</td>
          </tr>
          <tr>
            <td>INSURED</td>
            <td>{data?.customerFirstName + " " + data?.customerLastName}</td>
          </tr>
          <tr>
            <td>ADDRESS</td>
            <td>{data?.homeAddress}</td>
          </tr>
          <tr>
            <td>OCCUPATION</td>
            <td>{data?.occupation}</td>
          </tr>
          <tr>
            <td>TYPE OF POLICY</td>
            <td>Savings</td>
          </tr>
          {/* <tr>
            <td>RISK COVERED</td>
            <td>
              {policy_document_risk?.map((item, i) => (
                <p key={i}>
                  {i + 1}.{" "}
                  <span
                    className={`me-1 ${item?.description ? "fw-bold" : ""}`}
                  >
                    {item?.cover_name}
                  </span>
                </p>
              ))}
            </td>
          </tr> */}

          <tr>
            <td>LIFE COVER</td>
            <td>{life_cover?.life_cover_name}</td>
          </tr>
          <tr>
            <td>SAVINGS SUM ASSURED</td>
            <td>&#x20A6;{parseFloat(data?.sumAssured).toFixed(2)}</td>
          </tr>
          <tr>
            <td>SAVINGS INTEREST RATE</td>
            <td>{data?.interest_rate}%</td>
          </tr>
          <tr>
            <td>PREMIUM CONTRIBUTION</td>
            <td>&#x20A6;{data?.premuim_contribution}</td>
          </tr>
          <tr>
            <td>PAYMENT FREQUENCY</td>
            <td>{data?.repayment_frequency}</td>
          </tr>
          <tr>
            <td>DEATH BENEFIT</td>
            <td>Total Monthly Contribution</td>
          </tr>
          <tr>
            <td>EFFECTIVE DATE</td>
            <td>{moment(data?.effectiveDate).format("D-M-Y")}</td>
          </tr>
          {/* <tr>
            <td>APPROVAL DATE:</td>
            <td>
              {data?.poilcy_app_approval_date &&
                moment(data?.poilcy_app_approval_date).format("D-M-Y")}
            </td>
          </tr> */}
          <tr>
            <td>MATURITY / END DATE:</td>
            <td>{moment(data?.endDate).format("D-M-Y")}</td>
          </tr>
          <tr>
            <td>POLICY TENURE</td>
            <td>{data?.duration} months</td>
          </tr>
          <tr>
            <td>AGENT</td>
            <td>{data?.agentFirstName + " " + data?.agentLastName}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PolicySavingsScheduleDoc;
